
// @ts-nocheck
import locale_en_46js_6707fcff from "#nuxt-i18n/6707fcff";
import locale_fr_46js_cbd5b813 from "#nuxt-i18n/cbd5b813";

export const localeCodes =  [
  "en",
  "fr"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46js_6707fcff",
      load: () => Promise.resolve(locale_en_46js_6707fcff),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46js_cbd5b813",
      load: () => Promise.resolve(locale_fr_46js_cbd5b813),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-CA",
      name: "English",
      files: [
        {
          path: "C:/Users/brend/GIT/kas-warranty/i18n/locales/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr-CA",
      name: "Français",
      files: [
        {
          path: "C:/Users/brend/GIT/kas-warranty/i18n/locales/fr.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: false
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-CA",
    name: "English",
    files: [
      {
        path: "C:/Users/brend/GIT/kas-warranty/i18n/locales/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-CA",
    name: "Français",
    files: [
      {
        path: "C:/Users/brend/GIT/kas-warranty/i18n/locales/fr.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/